import { PaymentMethodType, PaymentChannelType } from './../constant';
export class Checkout3Config {
  allowCreditTerms: boolean;
  allowMultiPayment: boolean;
  allowLimitRoom: FeatureItem;
  allowLimitBudget: FeatureItem;
  allowCorporateFleet: boolean;
  allowMultiPaymentCorporateFleet: boolean;
  allowBookForTraveller: any;
  budgetSuggestion: number;
  configCheckout3: Checkout3ConfigField;
  enablePin: boolean;
}

export class Checkout3ConfigField {
  checkout3ConfigList: CheckoutConfig[];
  taxAddressEn: string;
  taxAddressTh: string;
  taxId: string;
  taxNameEn: string;
  taxNameTh: string;
}
export class CheckoutConfig {
  fieldId: string;
  fieldType: string;
  displayName?: string;
  displayNameTh: string;
  displayNameEn: string;
  defaultValue?: string;
  dropdownList?: DropdownConfig[];
  shortDescription?: string;
  shortDescriptionTh?: string;
  shortDescriptionEn?: string;
  require: boolean;
  childFiledId?: string;
  disabled = false;
}

export class DropdownConfig {
  value1En?: string;
  value1Th?: string;
  value2En?: string;
  value2Th?: string;
}

export class CostCenterDropdownItem {
  costCenterCodeTH: string;
  costCenterCodeEN: string;
  costCenterNameTH: string;
  costCenterNameEN: string;
  taxId: string;
  taxNameTH: string;
  taxNameEN: string;
  taxAddressTH: string;
  taxAddressEN: string;
}

export class InternalOrderConfig {
  display: boolean;
  require: boolean;
  internalOrderLabelTH: string;
  internalOrderLabelEN: string;
  internalOrderPlaceholderTH: string;
  internalOrderPlaceholderEN: string;
  type: string;
  internalOrderDropdown: InternalOrderDropdownItem[] = [];
}

export class InternalOrderDropdownItem {
  internalOrderCodeTH: string;
  internalOrderCodeEN: string;
  internalOrderNameTH: string;
  internalOrderNameEN: string;
}

export class AttachmentConfig {
  display: boolean;
  require: boolean;
  attachmentLabelTH: string;
  attachmentLabelEN: string;
  attachmentPlaceholderTH: string;
  attachmentPlaceholderEN: string;
}

export class FeatureItem {
  allow: boolean;
  amount: number;
}
export class PaymentChannelItem {
  paymentChannelName: string;
  title: string;
  subTitle: string;
  icon: string;
  hide: boolean = true;
  default: boolean = false;
  mainBookerPayment: string[];
  disable: boolean = false;

  constructor(paymentChannelName: string, title: string, subTitle: string, icon: string, mainBookerPayment: string[]) {
    this.paymentChannelName = paymentChannelName;
    this.title = title;
    this.subTitle = subTitle;
    this.mainBookerPayment = mainBookerPayment;
    this.icon = icon;
  }

}
export class Paymentable {
  mainBookerEmail: string;
  paymentChannels: PaymentChannelItem[]
  isOverBudget: boolean;
}
export class PaymentChannelCheckout {
  mainBookerEmail: string;
  isOverBudget: boolean;

  MULTI_PAYMENT = new PaymentChannelItem(
    PaymentChannelType.MULTI_PAYMENT,
    'payment-channel-type-multi-payment',
    undefined,
    'icon-card-add',
    [PaymentMethodType.creditTerm, PaymentMethodType.creditCard, PaymentMethodType.trueMoneyWallet, PaymentMethodType.fleetCard, PaymentMethodType.corporateFleet, PaymentMethodType.personalFleet])

  CREDIT_TERMS = new PaymentChannelItem(
    PaymentChannelType.CREDIT_TERMS,
    'payment-channel-type-credit-terms',
    undefined,
    'icon-credit-terms',
    [PaymentMethodType.creditTerm]);

  CREDIT_CARD = new PaymentChannelItem(
    PaymentChannelType.CREDIT_CARD,
    'payment-channel-type-credit-card',
    'payment-channel-type-personal-payment',
    'icon-debit-card',
    [PaymentMethodType.creditCard]);

  PERSONAL_FLEET = new PaymentChannelItem(
    PaymentChannelType.PERSONAL_FLEET,
    'payment-channel-type-personal-fleet',
    'บัตรฟลีทส่วนตัว',
    'icon-fleet-card',
    [PaymentMethodType.fleetCard]);

  CORPORATE_FLEET = new PaymentChannelItem(
    PaymentChannelType.CORPORATE_FLEET,
    'payment-channel-type-corporate-fleet',
    undefined,
    'icon-fleet-card',
    [PaymentMethodType.fleetCard]);

  FLEET_CARD = new PaymentChannelItem(
    PaymentChannelType.FLEET_CARD,
    'payment-channel-type-fleet-card',
    undefined,
    'icon-fleet-card',
    [PaymentMethodType.fleetCard]);

  TRUE_MONEY_WALLET = new PaymentChannelItem(
    PaymentChannelType.TRUE_MONEY,
    'payment-channel-type-true-money',
    'payment-channel-type-personal-payment',
    '',
    [PaymentMethodType.trueMoneyWallet]);

  QR_CODE = new PaymentChannelItem(
    PaymentChannelType.QR_CODE,
    'payment-channel-type-qr-code',
    'payment-channel-type-personal-payment',
    'icon-qr-code',
    [PaymentMethodType.qrCode]);

  E_WALLET = new PaymentChannelItem(
    PaymentChannelType.E_WALLET,
    'payment-channel-type-e-wallet',
    'payment-channel-type-personal-payment',
    '',
    [PaymentMethodType.eWallet]);

  IM_BANKING = new PaymentChannelItem(
    PaymentChannelType.IM_BANKING,
    'payment-channel-type-im-banking',
    'payment-channel-type-personal-payment',
    'icon-im-banking',
    [PaymentMethodType.imBanking]);

  PAY_AT_COUNTER = new PaymentChannelItem(
    PaymentChannelType.PAY_AT_COUNTER,
    'payment-channel-type-pay-at-counter',
    'payment-channel-type-personal-payment',
    'icon-pay-at-counter',
    [PaymentMethodType.payAtCounter]);

  public getPaymentable(): Paymentable {
    return {
      mainBookerEmail: this.mainBookerEmail,
      paymentChannels: Object.keys(this).filter((i) => i !== 'mainBookerEmail').map((i) => this[i]),
      isOverBudget: this.isOverBudget
    };
  }

}

export class MultiPaymentInfo {
  additionalChannel: PaymentChannelType;
  mainChannel: PaymentChannelType;
  creditTermsAmount: CreditTermsAmount;
  creditCardAmount: number;
}

export class CreditTermsAmount {
  booker: number;
  coBooker: number;
}


export class CheckOut3SubmitData {
  bookerEmail: string;
  checkOutComponentData: string;
  data: any;
}

export class UploadBookingDocumentResponse {
  path: string;
}



// WEBPACK FOOTER //
// ./src/app/model/checkout/checkout3-config.model.ts